import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImportDataResponse } from 'src/app/core/interfaces/import-data.interface';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-import-opening-inventory-prompt-modal',
  templateUrl: './import-opening-inventory-prompt-modal.component.html',
  styleUrls: ['./import-opening-inventory-prompt-modal.component.css']
})
export class ImportOpeningInventoryPromptModalComponent {
  @Input() importResult!: ImportDataResponse;

  constructor(
    public activeModal: NgbActiveModal,
    private localizationService: LocalizationService
  ) { }

  getCurrentLanguage(): string {
    return this.localizationService.getCachedLanguage() ?? 'en';
  }

  getMessage(): string {
    const isArabic = this.getCurrentLanguage() === 'ar';
    const count = this.importResult.data.countSuccess;
    
    if (isArabic) {
      return `تم استيراد ${count} صنف بنجاح. هل تريد استيراد الجرد الافتتاحي لهذه الأصناف؟`;
    } else {
      return `${count} products imported successfully. Would you like to import opening inventory for these products?`;
    }
  }

  onImportOpeningInventory(): void {
    this.activeModal.close('import');
  }

  onSkip(): void {
    this.activeModal.dismiss('skip');
  }
}

